import { Redirect } from 'expo-router';
import Head from 'expo-router/head';

import { DEFAULT_LOCALE } from '@todo/core/i18n/locales';
import { absoluteUrl, hreflangLinks } from '@todo/core/seo';

// Un-prefixed root. Always resolves to the default locale — <Redirect> handles
// JS-enabled clients (web and native) instantly; the meta-refresh + canonical
// are a host-agnostic fallback for crawlers/no-JS that doesn't depend on
// hosting-specific redirect config. In production public/_redirects answers
// "/" with a server-side 301 to /en before this page is ever served.
export default function RootIndex() {
  const target = absoluteUrl(DEFAULT_LOCALE);

  return (
    <>
      <Head>
        <html lang={DEFAULT_LOCALE} />
        <meta httpEquiv="refresh" content={`0;url=/${DEFAULT_LOCALE}`} />
        <link rel="canonical" href={target} />
        {hreflangLinks().map((link) => (
          <link key={link.hrefLang} rel="alternate" hrefLang={link.hrefLang} href={link.href} />
        ))}
      </Head>
      <Redirect href={{ pathname: '/[lang]', params: { lang: DEFAULT_LOCALE } }} />
    </>
  );
}
